import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight } from 'yoda-ui/yodaTheme';

const { medium } = YodaFontSize;

export const selectStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: YodaBorderRadius.small,
    paddingLeft: '6px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
    '& input::placeholder': {
      color: YodaColors.gray3,
      opacity: 0.8,
    },
  },
  '& + p.Mui-error': { fontWeight: 300 },
};

export const textFieldStyle = {
  '& label': {
    fontSize: medium,
    fontWeight: YodaFontWeight.light,
    lineHeight: '1.2rem',
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: YodaColors.textSecondary,
    },
  },
  '& .MuiAutocomplete-input': {
    fontSize: medium,
    fontWeight: YodaFontWeight.light,
    '&::placeholder': {
      color: YodaColors.textSecondary,
      opacity: 1,
    },
  },
  '& .MuiAutocomplete-endAdornment': {
    marginRight: '6px',
  },
};
